export const GET_NOTIFICATIONS_HISTORIC = 'GET_NOTIFICATIONS_HISTORIC';
export const SET_NOTIFICATIONS_HISTORIC_PAGINATION = 'SET_NOTIFICATIONS_HISTORIC_PAGINATION';
export const SET_NOTIFICATIONS_HISTORIC_FILTERS = 'SET_NOTIFICATIONS_HISTORIC_FILTERS';
export const RESET_NOTIFICATIONS_HISTORIC = 'RESET_NOTIFICATIONS_HISTORIC';
export const TOGGLE_NOTIFICATION_HISTORIC = 'TOGGLE_NOTIFICATION_HISTORIC';
export const ADD_NOTIFICATION_HISTORIC = 'ADD_NOTIFICATION_HISTORIC';
export const UPDATE_NOTIFICATION_HISTORIC = 'UPDATE_NOTIFICATION_HISTORIC';
export const GET_NOTIFICATION_HISTORIC_BY_ID = 'GET_NOTIFICATION_HISTORIC_BY_ID';
export const RESET_NOTIFICATION_HISTORIC_FORM = 'RESET_NOTIFICATION_HISTORIC_FORM';
export const GET_NOTIFICATION_HISTORIC_FORM_CONFIG = 'GET_NOTIFICATION_HISTORIC_FORM_CONFIG';
export const MODIFY_EDITING_NOTIFICATION_HISTORIC = 'MODIFY_EDITING_NOTIFICATION_HISTORIC';
export const ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC =
  'ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC';
export const REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC =
  'REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC';

export const UPDATE_SELF_NOTIFICATION_HISTORIC = 'UPDATE_SELF_NOTIFICATION_HISTORIC';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC =
  'MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_HISTORIC';

export const notifications_elementsBySections = {
  assets: [
    'notify.assets.add',
    'notify.assets.disable',
    'notify.assets.edit_request',
    'notify.assets.edit_accept',
    'notify.assets.edit_reject',
    'notify.assets.restore',
  ],
  // reports: ["notify.reports.depreciation", "notify.reports.disabled"],
};



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/constants/notifications_historic_constants.js